var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h2',{staticClass:"text-center"},[_vm._v("\n    404！NOT FOUND！\n  ")]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('router-link',{attrs:{"to":_vm.to}},[_c('h-button',{attrs:{"type":"primary"}},[_vm._v("首页")])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f40c9c60","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/core/404/index.vue
// module id = null
// module chunks = 